import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Position {
  id: number;
  name: string;
  description?: string;
  status: number;
  created_manager?: {
    full_name: string;
  };
}

export interface PositionListInfor {
  errors: unknown;
  position: Position;
  positionsListData: any;
  positionDetailData: any;
  isAuthenticated: boolean;
}

@Module
export default class PositionModule
  extends VuexModule
  implements PositionListInfor
{
  errors = {};
  position = {} as Position;
  isAuthenticated = !!JwtService.getToken();

  get Positions() {
    return this.positionsListData;
  }

  get PositionDetail() {
    return this.positionDetailData;
  }

  @Mutation
  [Mutations.POSITIONS_LIST_DATA](Position) {
    this.positionsListData = Position;
  }

  @Mutation
  [Mutations.POSITION_DETAIL_DATA](Position) {
    this.positionDetailData = Position;
  }

  @Action
  [Actions.POSITION_DETAIL](payload) {
    return ApiService.getDataDetail("/chucvu", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.POSITION_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.POSITIONS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/chucvu", payload)
        .then((data) => {
          this.context.commit(Mutations.POSITIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.POSITION_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/chucvu", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.POSITIONS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.POSITION_DELETE](id) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.delete(`/chucvu/${id}`)
        .then(() => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
